export function doRectanglesOverlap(
  firstRect: {position: {x: number; y: number}; width: number; height: number},
  secondRect: {position: {x: number; y: number}; width: number; height: number}
): boolean {
  const [firstLeft, firstRight] = [firstRect.position.x, firstRect.position.x + firstRect.width];
  const [firstTop, firstBottom] = [firstRect.position.y, firstRect.position.y + firstRect.height];
  const [secondLeft, secondRight] = [secondRect.position.x, secondRect.position.x + secondRect.width];
  const [secondTop, secondBottom] = [secondRect.position.y, secondRect.position.y + secondRect.height];

  return (
    firstLeft <= secondRight &&
    firstRight >= secondLeft &&
    firstTop <= secondBottom &&
    firstBottom >= secondTop
  );
}
